module.exports = __webpack_public_path__ + "media/images/subject_img/ELECTRICAL-ELECTRONIC ENGINEERING-19ab6e8133439756add190b6436dca7c.jpg";